<template>
  <div class="cards" :class="{ single: cards.length === 1 }">
    <Card
      v-for="(card, index) in cards"
      :key="card.id"
      :card="card"
      :grid="grid"
      :is-current="index === 0"
      @cardAccepted="$emit('cardAccepted')"
      @cardRejected="$emit('cardRejected')"
      @cardSkipped="$emit('cardSkipped')"
      @hideCard="$emit('hideCard')"
    />
  </div>
</template>

<script>
import Card from "./Card";

export default {
  components: {
    Card,
  },

  props: {
    grid: {
      type: Object,
      required: true,
    },

    cards: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.cards {
  position: relative;
  display: flex;
  /* margin-top: 20px; */
  width: 80vw;
  max-width: 80vw;
}

@media screen and (max-width: 1000px) {
  .cards {
    margin: 20px;
  }
}
</style>
